import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';


const AfficheAvisResto = async (page) => {
    return await axios.get(`${BASE_URL}/api/societe/afficheAvisRestaurant/${page}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const SuprimerAvisResto = async (idAvis) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteAvisRestaurant/${idAvis}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const AfficheAvisProduit = async (page) => {
    return await axios.get(`${BASE_URL}/api/societe/afficheAvisProduit/${page}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const SuprimerAvisProduit = async (idAvis) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteAvisProduit/${idAvis}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}




export { AfficheAvisResto, SuprimerAvisResto, AfficheAvisProduit, SuprimerAvisProduit }